import { openAlert } from './alertActions';
import { searchRestaurants as callSeachRestaurants } from '../../../api/pickup';
import { selectUserAddress } from '../selector/userSelectors.js';
import { extract } from '../../../utils/jsonApi';

const BASE = 'pickup :';

export const pickupActionTypes = {
  getRestaurantsStart: `${BASE} restaurants : fetch start`,
  getRestaurantsSuccess: `${BASE} restaurants : fetch SUCCESS`,
  getRestaurantsFailed: `${BASE} restaurants : fetch FAILED`,
};

export const searchRestaurants = (time) => async (dispatch, getState) => {
  const { geoLocation, addressId } = selectUserAddress(getState());
  try {
    dispatch({
      type: pickupActionTypes.getRestaurantsStart,
    });
    const data = await callSeachRestaurants({ addressId, geoLocation, time });
    const restaurants = extract(data, 'restaurant');
    dispatch({
      type: pickupActionTypes.getRestaurantsSuccess,
      restaurants,
    });
  } catch (e) {
    dispatch(
      openAlert({
        message: 'Can not get pick up restaurants',
        variant: 'error',
      })
    );
    dispatch({
      type: pickupActionTypes.getRestaurantsFailed,
      e,
    });
  }
};
